// extracted by mini-css-extract-plugin
module.exports = {"compressor_type":"compressor_type___1jvwU","compressor_item":"compressor_item___2G5S0","title":"title___1gtxr","description":"description___37bA0"};